import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import NoData from '@/components/common/no-data/NoData';
import ServiceGroupForm from '@/components/forms/form-service-group/ServiceGroupForm';
import { TForm } from '@/components/forms/form-service-group/ServiceGroupForm.types';
import { Skeleton } from '@/components/ui/skeleton';
import usePostServiceDivision from '@/hooks/queries/service-division-api/usePostServiceDivision';
import useGetServiceById from '@/hooks/queries/services-api/useGetServiceById';
import useFormattedDate from '@/hooks/useFormattedDate';
import { getTimestampUTC } from '@/utils/dates';
import { endOfDay, startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const CreateServiceGroup = () => {
  const { t } = useTranslation();
  const { id: serviceId } = useParams();
  const { data: service, isError, isLoading } = useGetServiceById(serviceId);
  const { mutate, isPending } = usePostServiceDivision();
  const { formattedDate } = useFormattedDate();
  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[50vh]" />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <NoData />
        <ErrorMessage />
      </>
    );
  }

  if (!service) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  const onSubmit = (values: TForm) => {
    const time = formattedDate({ date: values.startHour, dateFormat: 'time' });
    const startTime = values.startTime
      ? getTimestampUTC({
          date: startOfDay(values.startTime),
          tz: service.organization.tz
        })
      : undefined;
    const endTime = values.endTime
      ? getTimestampUTC({
          date: endOfDay(values.endTime),
          tz: service.organization.tz
        })
      : undefined;
    const payload = {
      service: service.id,
      name: values.name,
      description: values.description,
      startTime: startTime,
      startHour: time,
      endTime: endTime,
      duration: values.duration,
      quantity: 1,
      type: 'range' as const
    };
    mutate(payload);
  };

  return (
    <div className="mb-4">
      <GoBack />
      <div className="p-5 space-y-6 rounded-md bg-accent">
        <p className="font-bold text-md text-primary">
          {t('serviceDetail.createServiceGroup.title')} - {service.name}
        </p>
        <ServiceGroupForm onSubmit={onSubmit} isPending={isPending} />
      </div>
    </div>
  );
};

export default CreateServiceGroup;
